// extracted by mini-css-extract-plugin
export default {"container":"styles_container__yervQ","textWrapper":"styles_textWrapper__-VbSG","background":"styles_background__FgQ6h","progress":"styles_progress__wd6D-"};